
const $fe8489c4d7037bad$var$bodyEl = document.querySelector('body');
const $fe8489c4d7037bad$var$page = $fe8489c4d7037bad$var$bodyEl.dataset.page;
let $fe8489c4d7037bad$var$ctx;
if ($fe8489c4d7037bad$var$page === 'home') $fe8489c4d7037bad$var$ctx = document.getElementById('acquisitions').getContext('2d');
const $fe8489c4d7037bad$var$getItemlLocalStorage = function(keyName) {
    return localStorage.getItem(keyName);
};
const $fe8489c4d7037bad$var$setItemLocalStorage = function(keyName, data) {
    localStorage.setItem(keyName, JSON.stringify(data));
};
const $fe8489c4d7037bad$var$getChartData = function() {
    $fe8489c4d7037bad$var$setItemLocalStorage('label', $fe8489c4d7037bad$export$aa843cdac777ca60.data.labels);
    $fe8489c4d7037bad$var$setItemLocalStorage('data', $fe8489c4d7037bad$export$aa843cdac777ca60.data.datasets[0].data);
};
const $fe8489c4d7037bad$export$aa843cdac777ca60 = new Chart($fe8489c4d7037bad$var$ctx, {
    type: 'doughnut',
    data: {
        labels: $fe8489c4d7037bad$var$getItemlLocalStorage('label') ? JSON.parse($fe8489c4d7037bad$var$getItemlLocalStorage('label')) : [],
        datasets: [
            {
                label: 'Spending',
                data: $fe8489c4d7037bad$var$getItemlLocalStorage('data') ? JSON.parse($fe8489c4d7037bad$var$getItemlLocalStorage('data')) : [],
                backgroundColor: [
                    '#ef4444',
                    '#3b82f6',
                    '#facc15',
                    '#22c55e',
                    '#0b00aaff' // Others(purple)
                ],
                borderWidth: 0
            }
        ]
    },
    options: {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    color: '#fff',
                    font: {
                        size: 14
                    }
                }
            }
        }
    }
});
const $fe8489c4d7037bad$export$f07c621b7d36d1ec = function(category, amount) {
    const index = $fe8489c4d7037bad$export$aa843cdac777ca60.data.labels.indexOf(category);
    if (index !== -1) {
        $fe8489c4d7037bad$export$aa843cdac777ca60.data.datasets[0].data[index] += amount;
        // Get chart details from local storage
        $fe8489c4d7037bad$var$getChartData();
    } else {
        $fe8489c4d7037bad$export$aa843cdac777ca60.data.labels.push(category);
        $fe8489c4d7037bad$export$aa843cdac777ca60.data.datasets[0].data.push(amount);
        // Get chart details from local storage
        $fe8489c4d7037bad$var$getChartData();
    }
};


'use strict';
const $3fba0bda95caa784$var$bodyEl = document.querySelector('body');
const $3fba0bda95caa784$var$menu = document.querySelector('.nav');
const $3fba0bda95caa784$var$openMenuBtn = document.querySelector('.nav-open-btn');
const $3fba0bda95caa784$var$closeMenuBtn = document.querySelector('.nav-close-btn');
const $3fba0bda95caa784$var$formInput = document.querySelector('.upload');
const $3fba0bda95caa784$var$amountInput = document.querySelector('.amount');
const $3fba0bda95caa784$var$selectInput = document.querySelector('.select');
const $3fba0bda95caa784$var$dateInput = document.querySelector('.date');
const $3fba0bda95caa784$var$textareaInput = document.querySelector('.description');
const $3fba0bda95caa784$var$errorMessage = document.querySelectorAll('.error-msg');
const $3fba0bda95caa784$var$addExpenseBtn = document.querySelector('.add-expense-btn');
const $3fba0bda95caa784$var$transactionsListParent = document.querySelector('.transactions-list');
const $3fba0bda95caa784$var$totalSpendingWidget = document.querySelector('.total-spend-value');
const $3fba0bda95caa784$var$totalBalanceWidget = document.querySelector('.total-balance-value');
const $3fba0bda95caa784$var$budgetInput = document.querySelector('.budget-input');
const $3fba0bda95caa784$var$addBudgetBtn = document.querySelector('.add-budget-btn');
const $3fba0bda95caa784$var$budgetWidget = document.querySelector('.budget-value');
const $3fba0bda95caa784$var$clearTransactionsBtn = document.querySelector('.clear-transactions');
const $3fba0bda95caa784$var$page = $3fba0bda95caa784$var$bodyEl.dataset.page;
const $3fba0bda95caa784$export$ca000e230c0caa3e = {
    transaction: {},
    transactions: [],
    budget: '',
    chartData: {
        labels: [],
        data: []
    }
};
const $3fba0bda95caa784$var$openCloseMenuFtn = function(btn) {
    btn.addEventListener('click', ()=>{
        $3fba0bda95caa784$var$menu.classList.toggle('hidden');
        $3fba0bda95caa784$var$closeMenuBtn.classList.toggle('hidden');
        $3fba0bda95caa784$var$openMenuBtn.classList.toggle('hidden');
    });
};
const $3fba0bda95caa784$var$calcTotalSpending = function(transactions) {
    const totalSpending = transactions.reduce((acc, trans)=>{
        return acc + +trans.amount;
    }, 0);
    return totalSpending;
};
const $3fba0bda95caa784$var$calcTotalBalance = function(budget, totalSpending) {
    return budget - totalSpending;
};
const $3fba0bda95caa784$var$setItemLocalStorage = function(keyName, data) {
    localStorage.setItem(keyName, JSON.stringify(data));
};
const $3fba0bda95caa784$var$getItemlLocalStorage = function(keyName) {
    return localStorage.getItem(keyName);
};
window.addEventListener('DOMContentLoaded', function() {
    // Home page code base
    if ($3fba0bda95caa784$var$page === 'home') {
        const storage = $3fba0bda95caa784$var$getItemlLocalStorage('transactions');
        if (storage) $3fba0bda95caa784$export$ca000e230c0caa3e.transactions = JSON.parse(storage);
        // getting budget from the local storage
        const budget = $3fba0bda95caa784$var$getItemlLocalStorage('budget');
        if (budget) {
            $3fba0bda95caa784$export$ca000e230c0caa3e.budget = JSON.parse(budget);
            $3fba0bda95caa784$var$budgetWidget.textContent = `$${$3fba0bda95caa784$export$ca000e230c0caa3e.budget}`;
        }
        // Test
        const transaction = $3fba0bda95caa784$var$getItemlLocalStorage('transaction');
        if (transaction) $3fba0bda95caa784$export$ca000e230c0caa3e.transaction = JSON.parse(transaction);
        // Calling ftn to calculate total spending
        const totalSpending = $3fba0bda95caa784$var$calcTotalSpending($3fba0bda95caa784$export$ca000e230c0caa3e.transactions);
        $3fba0bda95caa784$var$totalSpendingWidget.textContent = `$${totalSpending}`;
        // Calling ftn to calculate total balance left 
        // & Checking if the total balance is less than zero
        const totalBalance = $3fba0bda95caa784$var$calcTotalBalance($3fba0bda95caa784$export$ca000e230c0caa3e.budget, totalSpending);
        $3fba0bda95caa784$var$totalBalanceWidget.textContent = totalBalance < 0 ? `-$${Math.abs(totalBalance)}` : `$${totalBalance}`;
        const newTransactionsArr = $3fba0bda95caa784$export$ca000e230c0caa3e.transactions.slice(-5);
        const renderExpense = function(data) {
            $3fba0bda95caa784$var$transactionsListParent.innerHTML = '';
            data.forEach((entry)=>{
                const markup = `
        <li>
        <p>${entry.description}</p>
        <p>${entry.category}</p>
        <p class="hidden">13-05-2025</p>
        <p>-$${entry.amount}</p>
        </li>
        <hr />
        `;
                $3fba0bda95caa784$var$transactionsListParent.insertAdjacentHTML("afterbegin", markup);
            });
        };
        renderExpense(newTransactionsArr);
        // Event listeners
        $3fba0bda95caa784$var$openCloseMenuFtn($3fba0bda95caa784$var$openMenuBtn);
        $3fba0bda95caa784$var$openCloseMenuFtn($3fba0bda95caa784$var$closeMenuBtn);
    }
    /////////////////////////////////////////
    const setError = function() {
        $3fba0bda95caa784$var$amountInput.classList.add('input-form-error');
        $3fba0bda95caa784$var$selectInput.classList.add('input-form-error');
        $3fba0bda95caa784$var$dateInput.classList.add('input-form-error');
        $3fba0bda95caa784$var$textareaInput.classList.add('input-form-error');
        // Error styling for small screen size
        $3fba0bda95caa784$var$errorMessage.forEach((el)=>el.classList.remove('hidden'));
        // Error styling for large screen size
        $3fba0bda95caa784$var$errorMessage.forEach((el)=>el.classList.remove('hidden-lg'));
    };
    const removeError = function() {
        $3fba0bda95caa784$var$amountInput.classList.remove('input-form-error');
        $3fba0bda95caa784$var$selectInput.classList.remove('input-form-error');
        $3fba0bda95caa784$var$dateInput.classList.remove('input-form-error');
        $3fba0bda95caa784$var$textareaInput.classList.remove('input-form-error');
        // Remove error for small screen size
        $3fba0bda95caa784$var$errorMessage.forEach((el)=>el.classList.add('hidden'));
        // Remove error for big screen size
        $3fba0bda95caa784$var$errorMessage.forEach((el)=>el.classList.add('hidden-lg'));
    };
    const validateInputs = function() {
        const amountInputValue = $3fba0bda95caa784$var$amountInput.value.trim();
        const selectInputValue = $3fba0bda95caa784$var$amountInput.value;
        const dateInputValue = $3fba0bda95caa784$var$dateInput.value;
        const textareaInputValue = $3fba0bda95caa784$var$textareaInput.value.trim();
        if (amountInputValue === '' || selectInputValue === '' || dateInputValue === '' || textareaInputValue === '') // Display error message
        setError();
        else {
            const dataArr = [
                ...new FormData($3fba0bda95caa784$var$formInput)
            ];
            const data = Object.fromEntries(dataArr);
            $3fba0bda95caa784$export$ca000e230c0caa3e.transactions.push(data);
            (0, $fe8489c4d7037bad$export$f07c621b7d36d1ec)(data.category, +data.amount);
            // store each transaction 
            $3fba0bda95caa784$var$setItemLocalStorage('transaction', data);
            // setting expense to local storage
            $3fba0bda95caa784$var$setItemLocalStorage('transactions', $3fba0bda95caa784$export$ca000e230c0caa3e.transactions);
            // Clearing form input
            $3fba0bda95caa784$var$formInput.reset();
            // Remove error msg
            removeError();
        }
    };
    // Add Expense page code base
    if ($3fba0bda95caa784$var$page === 'add-expense') {
        const storage = $3fba0bda95caa784$var$getItemlLocalStorage('transactions');
        if (storage) $3fba0bda95caa784$export$ca000e230c0caa3e.transactions = JSON.parse(storage);
        $3fba0bda95caa784$var$addExpenseBtn.addEventListener('click', function(e) {
            e.preventDefault();
            // validate user inputs
            validateInputs();
        });
        // Event listeners
        $3fba0bda95caa784$var$openCloseMenuFtn($3fba0bda95caa784$var$openMenuBtn);
        $3fba0bda95caa784$var$openCloseMenuFtn($3fba0bda95caa784$var$closeMenuBtn);
    }
    if ($3fba0bda95caa784$var$page === 'budget-page') {
        $3fba0bda95caa784$var$addBudgetBtn.addEventListener('click', function(e) {
            e.preventDefault();
            const budgetValue = $3fba0bda95caa784$var$budgetInput.value;
            if (budgetValue == '') {
                // Display error mesage
                $3fba0bda95caa784$var$budgetInput.classList.add('input-form-error');
                $3fba0bda95caa784$var$errorMessage.forEach((el)=>el.classList.remove('hidden'));
            } else {
                $3fba0bda95caa784$export$ca000e230c0caa3e.budget = budgetValue;
                $3fba0bda95caa784$var$setItemLocalStorage('budget', $3fba0bda95caa784$export$ca000e230c0caa3e.budget);
                // Remove error message
                $3fba0bda95caa784$var$budgetInput.classList.remove('input-form-error');
                $3fba0bda95caa784$var$errorMessage.forEach((el)=>el.classList.add('hidden'));
            }
            // Clearing form input
            $3fba0bda95caa784$var$budgetInput.value = '';
        });
        // Event listeners
        $3fba0bda95caa784$var$openCloseMenuFtn($3fba0bda95caa784$var$openMenuBtn);
        $3fba0bda95caa784$var$openCloseMenuFtn($3fba0bda95caa784$var$closeMenuBtn);
    }
    if ($3fba0bda95caa784$var$page === 'transactions-page') {
        const storage = $3fba0bda95caa784$var$getItemlLocalStorage('transactions');
        if (storage) $3fba0bda95caa784$export$ca000e230c0caa3e.transactions = JSON.parse(storage);
        const renderExpense = function(data) {
            $3fba0bda95caa784$var$transactionsListParent.innerHTML = '';
            data.forEach((entry)=>{
                const markup = `
        <li>
        <p>${entry.description}</p>
        <p>${entry.category}</p>
        <p class="hidden">13-05-2025</p>
        <p>-$${entry.amount}</p>
        </li>
        <hr />
        `;
                $3fba0bda95caa784$var$transactionsListParent.insertAdjacentHTML("afterbegin", markup);
            });
        };
        renderExpense($3fba0bda95caa784$export$ca000e230c0caa3e.transactions);
        // Event listeners
        $3fba0bda95caa784$var$openCloseMenuFtn($3fba0bda95caa784$var$openMenuBtn);
        $3fba0bda95caa784$var$openCloseMenuFtn($3fba0bda95caa784$var$closeMenuBtn);
        $3fba0bda95caa784$var$clearTransactionsBtn.addEventListener('click', function() {
            localStorage.clear();
            location.reload();
        });
    }
});


//# sourceMappingURL=path0.f8219eeb.js.map
